import { Card, Deck } from '../../ponk-shared-ts/src/Card'
import { Player } from '../../ponk-shared-ts/src/Player'
import { PonkServerInterface } from '../../ponk-shared-ts/src/PonkServerInterface'
import { GenerateFunnyNameHehe } from './name-generator'
import * as qrcode from 'qrcode'




window.onload = () => {
	console.log("starting PONK")

	const query : string|null = GetMatchURLQuery()

	const ponk = new PonkGameControlSurface(query)
}


class PonkGameControlSurface {
	server:               PonkServerInterface
	serverVersion:        string|null = null
	clientId:             string|null = null
	handCenter:           number      = 0
	lastTouchMove:        number      = 0
	pendingJoinMatchCode: string|null = null
	weStartedTheMatch:    boolean     = false


	constructor (matchQuery:string|null) {
		const ws = (location.protocol === "https:") ? "wss" : "ws"
		this.server = new PonkServerInterface(`${ws}://${window.location.host}/ws`)
		this.server.onServerConnect = this.WhenConnectedToServer.bind(this)
		this.server.onMatchCreated  = this.WhenMatchCreated.bind(this)
		this.server.onMatchJoined   = this.WhenMatchJoined.bind(this)
		this.server.onMatchStarted  = this.WhenMatchStarted.bind(this)
		this.server.onNextRound     = this.WhenNextRound.bind(this)
		this.server.onPulledCard    = this.WhenPulledCard.bind(this)
		this.server.onGameEnded     = this.WhenGameEnded.bind(this)
		this.server.onMatchReset    = this.WhenGameReset.bind(this)

		OnClick("#create-match-button", this.CreateMatchButtonClicked.bind(this))
		OnClick("#start-match-button", this.StartTheMatch.bind(this))
		OnClick("#join-match-button", this.JoinMatchById.bind(this))
		OnClick(".remaining-deck", this.DrawFromDeck.bind(this))
		OnClick("#play-again", this.SendResetMatch.bind(this))
		MultipleOnClick(".hand-area", ".playing-card", this.PlayCard.bind(this))

		EventOnAll(".player-hand", ".playing-card", "touchstart",  this.TouchStartPlayerHand.bind(this))
		EventOnAll(".player-hand", ".playing-card", "touchmove",   this.TouchMovePlayerHand.bind(this))

		if (matchQuery!=null)
			this.GoToMatchJoinView(matchQuery)
	}


	WhenConnectedToServer (clientId:string, serverVersion:string) : void {
		this.clientId      = clientId
		this.serverVersion = serverVersion
		SetInputValue("#player-name", GenerateFunnyNameHehe())
		SetElementHTML("#server-version", "v"+serverVersion)
	}


	// Document event callbacks
	// ==============================================================
	CreateMatchButtonClicked () : void {
		const matchName = GetInputValue("#match-name")
		this.server.createMatch(matchName)
	}


	StartTheMatch () : void {
		this.server.startMatch(this.server.matchCode!)
	}


	JoinMatchById () : void {
		if (this.pendingJoinMatchCode == null)
			throw new Error("We have no match code saved to join by")

		const nickname : string = GetInputValue("#match-join-nickname")

		this.server.joinMatch(this.pendingJoinMatchCode, nickname)
	}


	DrawFromDeck () : void {
		this.server.pullCard()
	}


	PlayCard (e : Element) : void {
		if (this.server.ponkGame == null)
			throw new Error("playing card while not in a game")

		const cardCode : string|null = GetElementAttribute(e, "code")
		if (cardCode == null) {
			console.log("clicked weird area on card, yuck")
			return
		}

		const card : Card|null = this.server.ponkGame.hand.TakeCardByCode(cardCode)
		if (card == null)
			throw new Error("Could not decipher card from cardcode, or not in hand")

		this.server.playCard(card)
	}


	SendResetMatch () : void  {		
		if (this.server.matchCode == null)
			throw new Error("match code not set")
		
		this.server.resetMatch(this.server.matchCode)
	}


	TouchStartPlayerHand (e : TouchEvent) : void {
		this.lastTouchMove = e.touches[0].screenX
	}


	TouchMovePlayerHand (e : TouchEvent) : void {		
		for (const change of e.changedTouches) {
			const move     : number = (this.lastTouchMove - change.screenX) * 0.02
			const handSize : number = this.server.GetPonkState()!.hand.cards.length
			this.handCenter = clamp(this.handCenter+move, 0, handSize-1)
			this.lastTouchMove = e.touches[0].screenX
		}

		this.UpdateHandPositions(this.server.GetPonkState()!.hand)
	}


	// Server signal callbacks
	// ==============================================================
	WhenMatchCreated (matchCode:string) : void {
		console.log("match created", matchCode)

		const nickname : string = GetInputValue("#player-name")
		this.weStartedTheMatch = true

		this.GenerateMatchQRCode(matchCode).then(_=> {
			this.GoToLobbyView(matchCode)
			this.server.joinMatch(matchCode, nickname)
		})
	}


	// fires when you or anyone else joins the match
	WhenMatchJoined (matchCode:string, playerList:Player[]) : void {
		console.log("match join event", matchCode)
		this.GoToLobbyView(matchCode)
		this.UpdateLobbyView(matchCode)
	}


	WhenMatchStarted (matchCode:string) : void {
		this.GoToMatchView()
	}


	WhenNextRound (matchCode:string, playerTurn:string) : void {
		console.log("next round", matchCode, playerTurn, this.server.GetPonkState()!.pile)
		this.UpdateHand(this.server.GetPonkState()!.hand)
		this.UpdatePile(this.server.GetPonkState()!.pile)
		this.UpdatePlayerList(this.server.playerList!, playerTurn)
	}


	WhenPulledCard  (matchCode:string, hand:Deck, card:Card) : void {
		this.UpdateHand(this.server.GetPonkState()!.hand)
		this.UpdatePile(this.server.GetPonkState()!.pile)
	}


	WhenGameEnded (matchCode:string, winner:Player|null) :void {
		// give players 500ms to process what just happened before ending
		setTimeout( () => this.GoToGameEndedView(winner), 500);
	}


	WhenGameReset (matchCode:string) : void  {
		this.GoToLobbyView(matchCode)
	}


	// Logic for updating the visuals
	// ==============================================================
	UpdateLobbyView (matchCode:string) : void {
		document.querySelector(".lobby-joined-list")
		if (this.server.playerList != null)
			SetElementHTML(".lobby-joined-list", this.GenerateLobbyJoinedList())

		if (this.weStartedTheMatch) {
			document.querySelector("#start-match-button")?.classList.remove("hidden")
		}
	}


	GenerateLobbyJoinedList () : string {
		let output : string = ""

		if (this.server.playerList == null)
			throw new Error("player list was null on updating jobby joined list")

		for (const joiner of this.server.playerList) {
			output += `<div class="joined-player"> ${joiner.nickname} joined </div>`
		}

		return output
	}


	async GenerateMatchQRCode (matchCode:string) : Promise<void> {
		const url = `https://${window.location.host}/?m=${matchCode}`
		const options = {
			color: {dark: "#55061C", light: "#f5edd9"}
		}

		await qrcode.toDataURL(url, options).then( (url:string) => {
			SetElementHTML(".match-qr-code", `
				<p>Match join code: ${matchCode}</p>	
				<img src="${url}"/>
			`)
		})
	}


	GoToLobbyView (matchCode:string) : void {
		this.FocusDialog(".match-lobby")
		this.UpdateLobbyView(matchCode)
	}


	GoToGameEndedView (winner:Player|null) : void {
		this.FocusDialog(".game-ended-dialog")

		let winMsg : string = ""
		if (winner != null)
			winMsg = `${winner.nickname} won the game`
		else
			winMsg = `You are all losers` 

		SetElementHTML(".game-ended-message", winMsg)
	}


	GoToMatchView () : void {
		this.FocusDialog(".game-area")

		this.UpdateHand(this.server.GetPonkState()!.hand)
		this.handCenter = 0
		this.UpdatePile(this.server.GetPonkState()!.pile)
		this.UpdatePlayerList(this.server.playerList!, this.server.playerTurn)
	}


	GoToMatchJoinView (matchCode:string) : void {
		this.FocusDialog(".match-join-view")

		this.pendingJoinMatchCode = matchCode

		// TODO: this should be match name, not code
		SetElementHTML(".match-join-name", `match ${matchCode}`)
		SetInputValue("#match-join-nickname", GenerateFunnyNameHehe())
	}


	FocusDialog (dialogQuery:string) : void {
		const dialogues = document.querySelectorAll(".dialog-box")
		for (const dialogBox of dialogues) {
			dialogBox.classList.add("hidden")
		}

		document.querySelector(dialogQuery)?.classList.remove("hidden")
	}


	UpdateHand (hand:Deck) : void {
		let cards : string = ""

		for (const i in hand.cards)
			cards += this.CreateCardHTML(hand.cards[i])

		SetElementHTML(".player-hand", cards)

		this.UpdateHandPositions(hand)
	}


	UpdateHandPositions (hand:Deck) : void {
		for (const i in hand.cards) {
			const ii     = parseInt(i)
			const card   = hand.cards[i]
			const relN   = ii - this.handCenter
			const cardEl = document.querySelector(`.playing-card[code='${card.Code()}']`) as HTMLElement

			cardEl.style = `
				translate: calc(-50% + ${relN*3}rem);
				transform: rotate(${relN*5}deg);
				z-index: ${40-ii};
			`
		}
	}


	UpdatePile (pile:Deck) : void {
		const topPile : Card|undefined = pile.LastPlayed()
		if (topPile == undefined)
			return

		SetElementHTML(".pile", this.CreateCardHTML(topPile))
	}


	UpdatePlayerList (playerList:Player[], currentPlayer:string|null) : void {
		console.log(`current playa '${currentPlayer}'`)

		
		var result : string = ""
		for (const p of playerList) {
			// edge case for yourself
			if (p.id == this.clientId) {
				if (p.id == currentPlayer)
					result += `<div> &nbsp; your turn ... </div>`
				else
					result += `<div> you </div>`
			}
			else {
				if (p.id == currentPlayer)
					result += `<div> &nbsp; ${p.nickname}'s turn ... </div>`
				else
					result += `<div> ${p.nickname} </div>`
			}
		}

		SetElementHTML(".player-list", result)
	}


	CreateCardHTML (card:Card) : string {
		const code  : string = card.Code()
		const color : string = card.Color()

		return `<div class="playing-card ${color}" code="${code}">
			<div class="info tr">
				<div class="rank"> ${card.ShortRank()}   </div>
				<div class="suit"> ${card.SuitGraphic()} </div>
			</div>
			<div class="info tl">
				<div class="rank"> ${card.ShortRank()}   </div>
				<div class="suit"> ${card.SuitGraphic()} </div>
			</div>
			<div class="info br">
				<div class="rank"> ${card.ShortRank()}   </div>
				<div class="suit"> ${card.SuitGraphic()} </div>
			</div>
			<div class="info bl">
				<div class="rank"> ${card.ShortRank()}   </div>
				<div class="suit"> ${card.SuitGraphic()} </div>
			</div>
		</div>`
	}
}


function SetInputValue (query:string, value:string) : void {
	(document.querySelector(query) as HTMLInputElement).value = value
}


function SetElementHTML (query:string, value:string) : void {
	(document.querySelector(query) as HTMLLinkElement).innerHTML = value
}


function GetInputValue (query:string) : string {
	return (document.querySelector(query) as HTMLInputElement).value
}


function GetElementAttribute (element:Element|null, attribute:string) : string|null {
	if (element == null)
			return null
	return (element as HTMLElement).getAttribute(attribute)
}


function OnClick (query:string, callback:()=>void) : void {
	const thing = document.querySelector(query) as HTMLElement
	if (thing == undefined)
		return
	thing.onclick = callback
}


function MultipleOnClick (parentQuery:string, match:string, callback: (el:Element)=>void) : void {
	const parentElement = document.querySelector(parentQuery)
	if (parentElement == null)
		throw new Error("no parent element found for event group")

	parentElement.addEventListener("click", (e) => {
		if (e.target == null)
			return
		
		const listItem = (e.target as HTMLElement).closest(match)
		console.log(listItem)

		if (listItem!=null && parentElement.contains(listItem))
			callback(listItem)
	})
}


function EventOnAll(parentQuery:string, match:string, event:string, callback:(e:any)=>void) : void {
	const parentElement = document.querySelector(parentQuery)
	if (parentElement == null)
		throw new Error("no parent element found for event group")

	parentElement.addEventListener(event, (e) => {
		if (e.target == null)
			return
		
		const listItem = (e.target as HTMLElement).closest(match)

		if (listItem && parentElement.contains(listItem))
			callback(e)
	})
}


function clamp (x:number, min:number, max:number) : number {
	return Math.min(Math.max(x, min), max)
}


function GetMatchURLQuery () : string|null {
	const urlParams = new URLSearchParams(window.location.search)
	const matchCode = urlParams.get("m")
	return matchCode
}